export type OnboardingStepId = 1 | 2;

export type OnboardingProgressInput = {
  whatsappConnected: boolean;
  funnelCustomized: boolean;
  whatsappSkipped: boolean;
  funnelSkipped: boolean;
};

export function isWhatsAppStepDone(i: OnboardingProgressInput): boolean {
  return i.whatsappConnected || i.whatsappSkipped;
}

export function isFunnelStepDone(i: OnboardingProgressInput): boolean {
  return i.funnelCustomized || i.funnelSkipped;
}

export function getCurrentOnboardingStep(
  i: OnboardingProgressInput,
): OnboardingStepId | null {
  if (!isWhatsAppStepDone(i)) return 1;
  if (!isFunnelStepDone(i)) return 2;
  return null;
}

export function isOnboardingComplete(i: OnboardingProgressInput): boolean {
  return getCurrentOnboardingStep(i) === null;
}
